import { createSlice } from "@reduxjs/toolkit";

export const optionsSlice = createSlice({
    name: "options",
    initialState: {
        options: {
            sidePanel: {
                isOpen: false,
                openedBefore: false,
                type: "",
                title: "",
                description: 0
            }
        }
    },
    reducers: {
        changeOptionSidePanel: (state, {payload}) => {
            payload.openedBefore = true
            state.options.sidePanel = payload;
        }
    }
})

export const sidePanelOption = (open = false, type = "", title = "", description = 0, stub) => {
    return {isOpen: open, type, title, description, stub }
};

export const { changeOptionSidePanel } = optionsSlice.actions;

export default optionsSlice.reducer;
